export const COMMON_REQUEST_GET_TENANT_BEGIN = 'COMMON_REQUEST_GET_TENANT_BEGIN';
export const COMMON_REQUEST_GET_TENANT_SUCCESS = 'COMMON_REQUEST_GET_TENANT_SUCCESS';
export const COMMON_REQUEST_GET_TENANT_FAILURE = 'COMMON_REQUEST_GET_TENANT_FAILURE';
export const COMMON_REQUEST_GET_TENANT_DISMISS_ERROR = 'COMMON_REQUEST_GET_TENANT_DISMISS_ERROR';
export const COMMON_REQUEST_GET_TENANT_URL = '/api/p/plp/tenants/{tenantName}'
export const COMMON_REQUEST_GET_AFQS_BEGIN = 'COMMON_REQUEST_GET_AFQS_BEGIN';
export const COMMON_REQUEST_GET_AFQS_SUCCESS = 'COMMON_REQUEST_GET_AFQS_SUCCESS';
export const COMMON_REQUEST_GET_AFQS_FAILURE = 'COMMON_REQUEST_GET_AFQS_FAILURE';
export const COMMON_REQUEST_GET_AFQS_DISMISS_ERROR = 'COMMON_REQUEST_GET_AFQS_DISMISS_ERROR';
export const COMMON_REQUEST_GET_AFQS_URL = '/api/p/plp/tenants/{tenantId}/afqs/live';
export const SET_SUPPORTED_BROWSER_VERSIONS = "SET_SUPPORTED_BROWSER_VERSIONS"



// WEBPACK FOOTER //
// ./src/features/common/redux/constants.js